import React from 'react';

class ShareButtons extends React.Component {
  constructor(props) {
    super(props);


    // used by React as the component name
    this.displayName = 'ShareButtons';
  }


  /**
   * Renders component
   * @returns {ReactElement} React element
   */
  render() {
    const className = 'component-share-buttons';
    const twitterHandle = this.props.twitterHandle || 'bleacherreport';
    const shareText = this.props.shareText || this.props.storyTitle;

    return (
      <div className={className}>
        <a
          href={'https://www.facebook.com/sharer.php?u=' + this.props.storyUrl}
          title='share on Facebook'
          target='_blank'
          className='share-button facebook'
        />
        <a
          href={'https://twitter.com/share?text=' + shareText +
            '&url=' + this.props.storyUrl + '&via=' + twitterHandle}
          title='share on Twitter'
          target='_blank'
          className='share-button twitter'
        />
      </div>
    );
  }
}


/**
 * Expected propTypes
 * @prop {String} shareText - Text to be displayed when sharing via Twitter
 * @prop {String} storyTitle - The title of the story
 * @prop {String} storyUrl - The url of the story
 * @prop {String} twitterHandle - A Twitter handle
 */
ShareButtons.propTypes = {
  shareText: React.PropTypes.string,
  storyTitle: React.PropTypes.string,
  storyUrl: React.PropTypes.string.isRequired,
  twitterHandle: React.PropTypes.string,
};


export default ShareButtons;



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/ShareButtons.jsx
 **/